import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { MinifiedBox, Lesson, HabirintData } from '@df/interfaces';
import { LessonService } from '@teacher/services/lesson.service';
import { takeUntil } from 'rxjs/operators';
import { TIMER_FOR_GET_HABIRINT_DATA } from '@app/app.constants';

@Component({
    selector: 'app-habirint-table',
    templateUrl: './habirint-table.component.html',
    styleUrls: ['./habirint-table.component.scss']
})
export class HabirintTableComponent implements OnInit, OnDestroy {
    @Input() lesson: Lesson;
    @Input() privilegeSettings: Array<any>;

    boxes: Array<MinifiedBox>;
    habirintData: HabirintData;
    columnBackgrounds: Array<string> = [
        '#f70002',
        // '#f75700',
        '#f88201',
        // '#f8b900',
        '#f8f801',
        '#a0f801',
        '#01f802',
        '#01f8f8',
        '#0000f7',
        '#a200f7',
        '#f800f8',
        '#f8008a'
    ];

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private lessonService: LessonService) {}

    ngOnDestroy() {
        this.destroy$.next(true);
    }

    ngOnInit() {
        if (this.lesson.is_habirint) {
            this.getBoxes();

            this.lessonService.getHabirintTableData(this.lesson.id).subscribe(resp => {
                this.habirintData = resp;
            });

            this.getHabirintData();
        }
    }

    get sortingStudents(): HabirintData['students_data'] {
        const students = this.habirintData.students_data.sort((item1, item2): number => {
            return item1.student_surname > item2.student_surname ? 1 : -1;
        });
        return students;
    }

    private getBoxes(): void {
        this.lessonService.getLessonBoxes(this.lesson.id).subscribe(resp => {
            this.boxes = resp['boxes'].filter(i => i.is_habirint);
        });
    }

    private getHabirintData(): void {
        this.lessonService
            .pollinGetHabirintTableData(this.lesson.id, TIMER_FOR_GET_HABIRINT_DATA)
            .pipe(takeUntil(this.destroy$))
            .subscribe(resp => {
                this.habirintData = resp;
            });
    }
}
